import React from 'react'
import { Form, Radio } from 'antd'

import DrawerFiltersLineCollapsable, { DrawerFiltersLineCollapsableItem } from 'components/DrawerFilters/DrawerFiltersLineCollapsable'

function ProductFilter () {
  return (
    <div className='proposal-radio-filter'>
      <DrawerFiltersLineCollapsable label='Produto'>
        <Form.Item
          name='isRefinancing'
          initialValue={undefined}
        >
          <Radio.Group>
            <DrawerFiltersLineCollapsableItem key='product-all'>
              <Radio value=''>{'Todos'}</Radio>
            </DrawerFiltersLineCollapsableItem>

            <DrawerFiltersLineCollapsableItem key='product-new'>
              <Radio value='false'>{'Novo contrato'}</Radio>
            </DrawerFiltersLineCollapsableItem>

            <DrawerFiltersLineCollapsableItem key='product-refin'>
              <Radio value='true'>{'Refinanciamento'}</Radio>
            </DrawerFiltersLineCollapsableItem>
          </Radio.Group>
        </Form.Item>
      </DrawerFiltersLineCollapsable>
    </div>
  )
}

export { ProductFilter }
